var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.2452H3C2.59 10.2452 2.25 9.83393 2.25 9.33797C2.25 8.84201 2.59 8.43073 3 8.43073H21C21.41 8.43073 21.75 8.84201 21.75 9.33797C21.75 9.83393 21.41 10.2452 21 10.2452Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.2935H3C2.59 16.2935 2.25 15.8822 2.25 15.3862C2.25 14.8903 2.59 14.479 3 14.479H21C21.41 14.479 21.75 14.8903 21.75 15.3862C21.75 15.8822 21.41 16.2935 21 16.2935Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.3418H3C2.59 22.3418 2.25 21.9305 2.25 21.4345C2.25 20.9386 2.59 20.5273 3 20.5273H21C21.41 20.5273 21.75 20.9386 21.75 21.4345C21.75 21.9305 21.41 22.3418 21 22.3418Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2404cb4610e467f92ef630f1d9fe1525.svg";
export { ForwardRef as ReactComponent };